import * as React from 'react';
import Moment from 'react-moment';

interface DateProps {
  date: string;
}

const DateWithFormat = ({date}: DateProps) => (
  <Moment format="MMM Do, YYYY">{date}</Moment>
);

export default DateWithFormat;
